export default "__VITE_ASSET__711a78a5__"